(function (angular) {
	'use strict';

	angular
		.module('settingsModule')
		.controller('EditBeneficiary', [
			'$filter',
			'$q',
			'$timeout',
			'EnumFactory',
			'globalConfig',
			'INVESTMENT_ENTITY_ID',
			'mixpanelFactory',
			'SettingsFactory',
			'urlFactory',
			EditBeneficiaryFunction
		]);

	function EditBeneficiaryFunction(
		$filter,
		$q,
		$timeout,
		EnumFactory,
		globalConfig,
		INVESTMENT_ENTITY_ID,
		mixpanelFactory,
		SettingsFactory,
		urlFactory
	) {
		var editBeneficiary = this;

		function buildPayload() {
			var payload = {};
			angular.extend(payload, editBeneficiary.beneficiary);

			payload.dateOfBirth = editBeneficiary.formattedDob;
			payload.stateAbbreviation = editBeneficiary.beneficiary.state.abbreviation;
			payload.beneficiaries = editBeneficiary.beneficiaries;
			payload.type = editBeneficiary.type;
			payload.beneficiaryRelationshipValue = editBeneficiary.relationship.value;
			payload.citizenshipCountryCode = editBeneficiary.citizenshipCountry.value;
			payload.residenceCountryCode = editBeneficiary.residenceCountry.value;

			if (angular.isDefined(editBeneficiary.beneficiary.ssn)) {
				payload.taxId = editBeneficiary.beneficiary.ssn;
			} else {
				payload.taxId = editBeneficiary.beneficiary.ein;
			}

			payload.sharePercentage = editBeneficiary.beneficiary.sharePercentage;

			return payload;
		}

		function getBeneficiaries(){
			SettingsFactory.beneficiary.getAll()
				.then(function (response) {
					editBeneficiary.beneficiaries = response;
					var beneficiaryToRemoveId = editBeneficiary.beneficiary.id;
					editBeneficiary.beneficiaries = $filter('filter')(editBeneficiary.beneficiaries, {type: editBeneficiary.type}, true);

					if(angular.isDefined(beneficiaryToRemoveId)) {
						editBeneficiary.beneficiaries = $filter('omit')(editBeneficiary.beneficiaries, function (beneficiary) {
							return beneficiary.id === beneficiaryToRemoveId;
						});
					}

					editBeneficiary.updateTotalPercentage();
				});
		}

		function getCountryFromCode(countryCode) {
			return $filter('filter')(editBeneficiary.countries, {'value': countryCode}, true)[0];
		}

		function setEditBeneficiaryAttributes() {
			editBeneficiary.beneficiaryName = editBeneficiary.beneficiary.name;
			editBeneficiary.residenceCountry = getCountryFromCode(editBeneficiary.beneficiary.residenceCountryCode);
			editBeneficiary.citizenshipCountry = getCountryFromCode(editBeneficiary.beneficiary.citizenshipCountryCode);
			editBeneficiary.relationship = $filter('findSelectedOption')(editBeneficiary.beneficiary.beneficiaryRelationshipValue, 'value', editBeneficiary.relationships);
			editBeneficiary.beneficiary.state = $filter('findSelectedOption')(editBeneficiary.beneficiary.stateAbbreviation, 'abbreviation', editBeneficiary.states);

			getBeneficiaries();
			editBeneficiary.setIsIndividualRelationship();
		}

		function setNewBeneficiaryAttributes() {
			editBeneficiary.beneficiaryName = 'This Beneficiary';
			editBeneficiary.beneficiary = {
				state: editBeneficiary.states[0]
			};
			getBeneficiaries();
		}

		function setCountriesAndStates() {
			var deferred = $q.defer();
			var residenceCountryCode = 'US';
			var citizenshipCountryCode = 'US';

			$q.all({
				states: EnumFactory.states.get(residenceCountryCode),
				countries: EnumFactory.countries.get()
			}).then(function(response) {
				angular.extend(editBeneficiary, response);
				editBeneficiary.residenceCountry = getCountryFromCode(residenceCountryCode);
				editBeneficiary.citizenshipCountry = getCountryFromCode(citizenshipCountryCode);

				deferred.resolve();
			});

			return deferred.promise;
		}

		function setRelationships() {
			var deferred = $q.defer();

			EnumFactory.relationships.get()
				.then(function (response) {
					$timeout(function() {
						editBeneficiary.relationships = response;
						if(editBeneficiary.beneficiary) {
							editBeneficiary.relationship = $filter('filter')(editBeneficiary.relationships, {'value': editBeneficiary.beneficiary.relationship}, true)[0] || editBeneficiary.relationships[0];
						} else {
							editBeneficiary.relationship = editBeneficiary.relationships[0];
						}

						editBeneficiary.setIsIndividualRelationship();

						deferred.resolve(response);
					});
				});

			return deferred.promise;
		}

		editBeneficiary.setIsIndividualRelationship = function () {
			editBeneficiary.isIndividualRelationship = editBeneficiary.relationship.value === 'SPOUSE' || editBeneficiary.relationship.value === 'NON_SPOUSE_INDIVIDUAL';
		};

		editBeneficiary.updateBeneficiaryName = function () {
			if (editBeneficiary.isIndividualRelationship && editBeneficiary.beneficiary && editBeneficiary.beneficiary.firstName && editBeneficiary.beneficiary.lastName) {
				editBeneficiary.beneficiaryName = editBeneficiary.beneficiary.firstName + ' ' + editBeneficiary.beneficiary.lastName;
			} else if (!editBeneficiary.isIndividualRelationship && editBeneficiary.beneficiary && editBeneficiary.beneficiary.companyName) {
				editBeneficiary.beneficiaryName = editBeneficiary.beneficiary.companyName;
			} else {
				editBeneficiary.beneficiaryName = 'This Beneficiary';
			}
		};

		editBeneficiary.updateTotalPercentage = function () {
			if(angular.isDefined(editBeneficiary.beneficiaries) && editBeneficiary.beneficiaries.length === 0) {
				editBeneficiary.totalPercentage = 100;
				editBeneficiary.beneficiary.sharePercentage = 100;
			} else {
				var total = angular.isDefined(editBeneficiary.beneficiary.sharePercentage) ? parseInt(editBeneficiary.beneficiary.sharePercentage) : 0;

				editBeneficiary.beneficiaries.forEach(function (beneficiary) {
					if (angular.isDefined(beneficiary.sharePercentage)) {
						total += parseInt(beneficiary.sharePercentage);
					}
				});

				editBeneficiary.totalPercentage = total;
				editBeneficiary.beneficiaryForm.$setValidity('totalPercentage', editBeneficiary.totalPercentage === 100);
			}
		};

		editBeneficiary.handleSubmit = function () {
			var payload = buildPayload();
			var form = editBeneficiary.beneficiaryForm;
			var submitPromise;

			if (angular.isDefined(editBeneficiary.beneficiary.id)) {
				submitPromise = SettingsFactory.beneficiary.update(form, payload, editBeneficiary.beneficiary.id);
			} else {
				submitPromise = SettingsFactory.beneficiary.post(form, payload);
			}

			submitPromise
				.then(function() {
					urlFactory.redirect('/account/investment-accounts/' + INVESTMENT_ENTITY_ID + '/individual-account/beneficiaries/success');
				})
				.catch(function() {
					editBeneficiary.formSubmitted = false;
				});
		};

		editBeneficiary.$onInit = function () {
			editBeneficiary.formSubmitted = false;
			angular.extend(editBeneficiary, globalConfig);

			var setCountriesAndStatesPromise = setCountriesAndStates();
			var setRelationshipsPromise = setRelationships();

			$q.all({
				setCountriesAndStates: setCountriesAndStatesPromise,
				setRelationships: setRelationshipsPromise
			}).then(function() {
				if (editBeneficiary.beneficiary) {
					SettingsFactory.beneficiary.get(editBeneficiary.beneficiary)
						.then(function(response) {
							$timeout(function() {
								editBeneficiary.beneficiary = response;
								editBeneficiary.type = response.type;
								setEditBeneficiaryAttributes();
							});
						});

				} else {
					setNewBeneficiaryAttributes();
				}
			});

			mixpanelFactory.track('Beneficiary settings viewed');
		};
	}
})(window.angular);